import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ReactGA from "react-ga";
import { LngLatBounds } from "mapbox-gl";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import NewRouteIcon from "@material-ui/icons/Refresh";
import BikeNodeMap from "../atoms/BikeNodeMap";
import BikeNodes from "../atoms/BikeNodes";
import DownloadGpxButton from "./DownloadGpxButton";

const styles = {
  button: { marginTop: 10 },
  arrowBack: { margin: "0 10px 0 20px" },
  arrowForward: { margin: "0 20px 0 10px" },
  startNavigationButton: { margin: "0 20px" }
};

class BikeNodeNav extends Component {
  constructor(props) {
    super(props);
    const { activeNodeIndex, geojson } = props;
    this.state = {
      activeNodeIndex: 0,
      fitBounds: null,
      navigationStarted: false,
      showModal: false
    };
    const { type } = props;
    if (type === "generated") {
      localStorage.setItem("generatedgeojson", JSON.stringify(geojson));
    } else if (type === "ambassador") {
      localStorage.setItem("ambassadorgeojson", JSON.stringify(geojson));
    }
    let fitBounds;
    if (activeNodeIndex) {
      this.state.activeNodeIndex = activeNodeIndex;
      this.state.navigationStarted = true;
      fitBounds = this.fitNextSegment(activeNodeIndex, activeNodeIndex + 1);
    } else {
      localStorage.setItem("generatedactiveNode", 0);
      const { coordinates } = geojson.features[0].geometry;
      const boundsCoords = coordinates.reduce(function(bounds, coord) {
        return bounds.extend(coord);
      }, new LngLatBounds(coordinates[0], coordinates[0]));
      fitBounds = boundsCoords.toArray();
    }

    this.state.fitBounds = fitBounds;

    let routesGenerated = localStorage.getItem("routesGenerated");
    if (routesGenerated === null) {
      this.state.routesGenerated = 0;
    } else {
      this.state.routesGenerated = parseInt(routesGenerated, 10);
    }

    if (
      routesGenerated % 10 === 0 &&
      routesGenerated !== 0 &&
      this.state.routesGenerated !== 0
    ) {
      this.state.showModal = true;
    }
  }

  onNextNode = () => {
    const { type } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Show next node",
      label: type
    });
    this.setState(state => {
      const { activeNodeIndex } = state;
      const newIndex = activeNodeIndex + 1;
      localStorage.setItem("generatedactiveNode", newIndex);
      const fitBounds = this.fitNextSegment(activeNodeIndex, newIndex);
      return { activeNodeIndex: newIndex, fitBounds };
    });
  };

  onPreviousNode = () => {
    const { type } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Show previous node",
      label: type
    });
    this.setState(state => {
      const { activeNodeIndex } = state;

      const newIndex = activeNodeIndex - 1;
      localStorage.setItem("generatedactiveNode", newIndex);
      const fitBounds = this.fitNextSegment(activeNodeIndex - 1, newIndex - 1);

      return { activeNodeIndex: newIndex, fitBounds };
    });
  };

  startNavigation = () => {
    const { type } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Start navigation",
      label: type
    });
    const fitBounds = this.fitNextSegment(-1, 0);
    this.setState({ navigationStarted: true, fitBounds });
  };

  fitNextSegment = (nodeIndex1, nodeIndex2) => {
    try {
      const { geojson } = this.props;

      let p1;
      let p2;
      if (nodeIndex1 === -1 || nodeIndex2 === -1) {
        p1 = geojson.features[0].geometry.coordinates[0];
        p2 = [geojson.pois[0].lon, geojson.pois[0].lat];
      } else if (nodeIndex2 === geojson.pois.length) {
        p1 = geojson.features[0].geometry.coordinates[0];
        const lastIndex = geojson.pois.length - 1;
        p2 = [geojson.pois[lastIndex].lon, geojson.pois[lastIndex].lat];
      } else if (nodeIndex1 === geojson.pois.length) {
        const lastIndex = geojson.pois.length - 1;
        p1 = [geojson.pois[lastIndex].lon, geojson.pois[lastIndex].lat];
        p2 = geojson.features[0].geometry.coordinates[0];
      } else {
        p1 = [geojson.pois[nodeIndex1].lon, geojson.pois[nodeIndex1].lat];
        p2 = [geojson.pois[nodeIndex2].lon, geojson.pois[nodeIndex2].lat];
      }

      if (p1[0] < p2[0]) {
        if (p1[1] > p2[1]) {
          const tmp = p1[1];
          p1[1] = p2[1];
          p2[1] = tmp;
        }
      } else {
        if (p1[1] < p2[1]) {
          const tmp = p1[0];
          p1[0] = p2[0];
          p2[0] = tmp;
        } else {
          const tmp = p1;
          p1 = p2;
          p2 = tmp;
        }
      }
      return [p1, p2];
    } catch (err) {
      // console.error(err);
      return null;
    }
  };

  closeDialog = routesGenerated => {
    this.setState({
      showModal: false,
      routesGenerated: routesGenerated + 1
    });
    localStorage.setItem("routesGenerated", routesGenerated + 1);
  };

  render() {
    const {
      fitBounds,
      activeNodeIndex,
      navigationStarted,
      showModal,
      routesGenerated
    } = this.state;
    const { geojson, classes, type, reset } = this.props;

    const previousDisabled = !navigationStarted || activeNodeIndex === 0;

    const nextDisabled =
      !navigationStarted || activeNodeIndex === geojson.pois.length;

    if (geojson.pois && activeNodeIndex === geojson.pois.length - 1) {
      const { type } = this.props;
      ReactGA.event({
        category: "Route",
        action: "End of route",
        label: type
      });
    }

    return (
      <div>
        <Dialog
          open={showModal}
          aria-labelledby="form-dialog-title"
          onClose={() => {
            this.closeDialog(routesGenerated);
          }}
        >
          <DialogTitle id="form-dialog-title">
            Je hebt al {routesGenerated} routes gemaakt!
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Heb je even tijd om wat feedback te geven? Dan kan je{" "}
              <a
                href="https://vrtenquete.typeform.com/to/xu4ztm"
                target="_blank"
                rel="noreferrer noopener"
              >
                hier
              </a>{" "}
              het formulier invullen. Dit duurt normaal maar een paar minuutjes.
              Alvast bedankt!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className={classes.button}
              variant="raised"
              color="primary"
              type="submit"
              onClick={() => {
                this.closeDialog(routesGenerated);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <BikeNodeMap fitBounds={fitBounds} geojson={geojson} type={type} />

        {type === "generated" ? (
          <div>
            <BikeNodes
              actualDistance={geojson.actualDistance}
              route={geojson.pois}
              activeNodeIndex={activeNodeIndex}
              // onNextNode={this.onNextNode}
              navigationStarted={navigationStarted}
            />
            <DownloadGpxButton geojson={geojson} />
            {!navigationStarted ? (
              <Button
                variant="raised"
                color="primary"
                size="large"
                className={classes.startNavigationButton}
                onClick={this.startNavigation}
              >
                Starten · {geojson.actualDistance}km
              </Button>
            ) : (
              <React.Fragment>
                <Button
                  variant="fab"
                  aria-label="vorige Knooppunt"
                  disabled={previousDisabled}
                  onClick={this.onPreviousNode}
                  className={classes.arrowBack}
                >
                  <ArrowBackIcon />
                </Button>
                <Button
                  variant="fab"
                  aria-label="volgend Knooppunt"
                  disabled={nextDisabled}
                  onClick={this.onNextNode}
                  className={classes.arrowForward}
                >
                  <ArrowForwardIcon />
                </Button>
              </React.Fragment>
            )}
            <Button
              variant="fab"
              aria-label="nieuwe route maken"
              onClick={reset}
            >
              <NewRouteIcon />
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

BikeNodeNav.propTypes = {
  classes: PropTypes.object.isRequired,
  geojson: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  reset: PropTypes.func,
  activeNodeIndex: PropTypes.number
};
export default withStyles(styles)(BikeNodeNav);



// WEBPACK FOOTER //
// ./src/NewRoute/components/BikeNodeNav.js